<template>
  <v-row>
    <v-layout class="split">
      <v-col cols="12" md="4" class="left pa-0 d-none d-md-block">
        <v-img
          src="https://rainorshinemamma.com/wp-content/uploads/2013/09/boy-blowing-bubbles-1024x683.jpg"
          lazy-src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcT1eDqKu6RJzd9Ys-Yh5YVrMr8RDVVKi027MzOmudYjN3YL1uHo&usqp=CAU"
          style="height:100vh"
        >
          <v-overlay absolute color="#f0eff6" opacity="0.85">
            <v-container style="padding: 0px 93px">
              <span class="intro-text">
                Every child can learn, just not the same day or the same way.
              </span>
            </v-container>
          </v-overlay>
        </v-img>
      </v-col>
      <v-col
        cols="12"
        md="8"
        style="background: linear-gradient(180deg, #F0F0F6 0%, #FFFFFF 100%);"
        align="center"
        class="pa-0 right"
      >
        <v-container class="pa-0">
          <v-row class="ma-2" justify="center" align="center">
            <span class="welcome me-6 mt-6" align-self="centre"
              >Welcome To</span
            >
            <div style="height: 108px;width: 171px;">
              <v-img :src="logo" align-self="centre"></v-img>
            </div>
          </v-row>

          <router-view></router-view>
        </v-container>
      </v-col>
      <!-- <BottomNavigation v-if="$store.state.isMobile" /> -->
    </v-layout>
  </v-row>
</template>

<script>
  // import BottomNavigation from "../../components/BottomNavigation/BottomNavigation";
  export default {
    name: "AuthLayout",
    components: {
      // BottomNavigation,
    },
    data() {
      return {
        logo: require("@/assets/EblityLogo.png"),
        loginImage: require("@/assets/loginimage.png"),
      };
    },
    computed: {},
    watch: {},
    methods: {},
    mounted() {},
    beforeCreate() {},
    created() {
      console.log(this.$route.query);

      if (this.$store.state.userUTM.utm_source == "Direct")
        this.$store.state.userUTM.utm_source = this.$route.query.utm_source
          ? this.$route.query.utm_source
          : "Direct";
      if (this.$store.state.userUTM.utm_medium == "None")
        this.$store.state.userUTM.utm_medium = this.$route.query.utm_medium
          ? this.$route.query.utm_medium
          : "None";
      if (this.$store.state.userUTM.utm_campaign == "None")
        this.$store.state.userUTM.utm_campaign = this.$route.query.utm_campaign
          ? this.$route.query.utm_campaign
          : "None";
    },
  };
</script>

<style lang="scss" scoped>
  //   @import "HeaderSectionStyle.scss";
</style>

<style lang="scss" scoped>
  @import "css/LoginStyle.scss";
</style>

<style scoped>
  .split {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .left {
    background-color: teal;
    overflow-y: scroll; /* it works! */
  }
  .right {
    flex: 1;
    background-color: orange;
    overflow-y: scroll; /* it works! */
  }
</style>
